import styled, { css } from 'styled-components';
import { FlexJustifySpaceBetweenAlignCenter } from 'components/primitives/flex';
import { RefObject } from 'react';

interface CounterIconProps {
  type?: 'plus' | 'minus';
}

const CounterIcon = ({ type = 'plus' }: CounterIconProps) => {
  const Icon = type === 'plus' ? CounterPlusIcon : CounterMinusIcon;

  return (
    <IconWrapper>
      <Icon />
    </IconWrapper>
  );
};

const CounterMinusIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3.3335 8H12.6668" stroke="#17263C" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const CounterPlusIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3.3335 8.00001H12.6668M8.00016 3.33334V12.6667"
      stroke="#17263C"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

interface CounterProps {
  minimum: number;
  boatCapacity: number;
  value: number;
  buttonSize?: number;
  onClick?: (count: number) => void;
  register?: RefObject<HTMLInputElement>;
  disabled?: boolean;
}

const Counter = ({ minimum, disabled, boatCapacity, value, register, onClick, buttonSize = 32 }: CounterProps) => {
  const downDisabled = disabled || value <= minimum;
  const upDisabled = disabled || value >= boatCapacity;

  return (
    <CounterWrapper>
      <div style={{ width: buttonSize, height: buttonSize }}>
        <CounterButton
          data-testid="minus-button"
          isDisabled={downDisabled}
          onClick={() => (downDisabled ? null : onClick(value - 1))}
        >
          <CounterIcon type="minus" />
        </CounterButton>
      </div>
      <CounterLabel>
        <input min={1} name="passengers" type="hidden" value={value} ref={register || null} readOnly />
        <CounterSpan data-testid="passengers">{value === 14 ? `${value}+` : value}</CounterSpan>
      </CounterLabel>
      <div style={{ width: buttonSize, height: buttonSize }}>
        <CounterButton
          data-testid="plus-button"
          isDisabled={upDisabled}
          onClick={() => (upDisabled ? null : onClick(value + 1))}
        >
          <CounterIcon type="plus" />
        </CounterButton>
      </div>
    </CounterWrapper>
  );
};

export default Counter;

const CounterWrapper = styled(FlexJustifySpaceBetweenAlignCenter)`
  width: 100%;
  height: 100%;
  gap: 24px;
`;

const CounterButton = styled.button.attrs({ type: 'button' })<{ isDisabled: boolean }>`
  border-radius: 8px;
  &:focus {
    outline: 0;
  }
  ${({ isDisabled }) =>
    isDisabled &&
    css`
      filter: grayscale(100%);
      opacity: 0.4;
      cursor: default;
    `};
`;

const CounterLabel = styled.div`
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #17233c;
  text-align: center;
  border: none;
`;

const CounterSpan = styled.span`
  font-size: 18px;
  font-weight: 500;
`;

const IconWrapper = styled.div`
  width: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 32px;
  border-radius: 50%;
  border: 1px solid #dbdfe5;
  background: #fff;

  svg {
    width: 16px;
    height: 16px;
  }
`;
